import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'page-loader',
    template: `
    @if (show || extraShowCondition) {
      <div class="loader-backdrop">
        <div class="loader-content">
          <mat-spinner diameter="35"></mat-spinner>
          @if (checkIfString() && show) {
            <p class="mt-3">{{show}}</p>
          }
        </div>
      </div>
    }
    <ng-content></ng-content>
    `,
    styleUrls: ['./page-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageLoader implements OnChanges {
  @Input() public show:  boolean | string;
  @Input() public extraShowCondition: any; //this can be anything, for example sometimes we need to check if some part of html has rendered in background before disabling loader

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.extraShowCondition) {
      console.log('Show loading: ', changes.extraShowCondition.currentValue);
    }
  }

  public checkIfString(): boolean{
    return typeof this.show === 'string';
  }

  public checkIfBoolean(): boolean{
    return typeof this.show === 'boolean';
  }
}

